import { get } from 'lodash-es'
import { ready } from '~/core'

ready('webinars', '.webinars', (webinars) => {
  const cardContainer = webinars.querySelector('.webinars__cards')
  const cards = [...webinars.querySelectorAll('.webinars__card')]
  const filters = webinars.querySelectorAll('.webinars__filter')
  const dropdown = webinars.querySelector('.webinars__dropdown select')
  const selected = webinars.querySelector('.webinars__filter--selected')
  const dropdownLabel = webinars.querySelector('.webinars__dropdown-text')
  const webinarsNote = webinars.querySelector('.webinars__note')
  const baseDropdownOptions = []
  const baseCards = []
  let pagedCards = []

  let currentLang = selected?.getAttribute('data-for')
  const noResultsText = webinars.getAttribute('data-no-results')
  const pageAmount = 12
  const loadMonthOptionData = () => {
    const dropdownOptions = webinars.querySelectorAll('.webinars__dropdown option')
    dropdownOptions.forEach((dropdownOption) => {
      baseDropdownOptions.push({
        text: dropdownOption.text,
        value: dropdownOption.value,
        dataEnglish: dropdownOption.getAttribute('data-english'),
        dataSpanish: dropdownOption.getAttribute('data-spanish'),
      })
    })
  }
  const loadCardData = () => {
    cards.forEach((card) => {
      baseCards.push({
        month: card.getAttribute('data-month'),
        language: card.getAttribute('data-language'),
      })
    })
  }

  const updateCards = (data) => {
    cardContainer.innerHTML = ''
    if (data.length === 0) {
      const noResults = `<div class="webinars__noresults">${noResultsText}</div>`
      cardContainer.insertAdjacentHTML('beforeend', noResults)
    } else {
      data.forEach((card) => {
        cardContainer.appendChild(card)
      })
    }
  }

  const updateDropDown = (language, preSelectedMonth) => {
    for (const option of dropdown.querySelectorAll('option')) {
      if (option) {
        if (option.value !== 'all') {
          option.remove()
        } else {
          option.label = getTranslation(language, option)
          option.text = getTranslation(language, option)
        }
      }
    }

    baseDropdownOptions.forEach((baseDropdownOption) => {
      if (baseDropdownOption.value !== 'all') {
        let option = document.createElement('option')
        option.value = baseDropdownOption.value
        option.setAttribute('data-english', baseDropdownOption.dataEnglish)
        option.setAttribute('data-spanish', baseDropdownOption.dataSpanish)
        option.text = getTranslation(language, option)
        option.setAttribute('data-month', option.value)

        if (preSelectedMonth) {
          if (preSelectedMonth === option.value) {
            option.selected = true
          }
        }
        dropdown.appendChild(option)
      }
    })

    for (const option of dropdown.querySelectorAll('option')) {
      if (option.value !== 'all') {
        let month = option.getAttribute('data-month')

        let exists = baseCards.filter((card, i) => {
          let m = card.month
          let l = card.language
          if (l == language && m == month) {
            return true
          }
          return false
        })

        if (exists.length == 0) {
          option.remove()
        }
      }
    }

    var selectedMonth = dropdown.options[dropdown.selectedIndex].value
    if (!selectedMonth) {
      let defaultOption = dropdown.querySelector('option[value="all"]')
      if (defaultOption) {
        defaultOption.selected = true
      }
    }
  }
  const sort = (lang, month) => {
    currentLang = lang
    let filtered = cards
    if (!month) {
      month = dropdown.value
    }
    filtered = filtered.filter((card, i) => {
      let m = card.getAttribute('data-month')
      let l = card.getAttribute('data-language')
      if (month == 'all') {
        if (l == lang) return true
      } else {
        if (l == lang && m == month) return true
      }
    })
    return filtered
  }

  const getTranslation = (lang, object) => {
    var data = 'data-english'
    if (lang == 'Spanish') {
      data = 'data-spanish'
    }
    return object.getAttribute(data)
  }

  filters.forEach(function (clickedFilter) {
    clickedFilter.addEventListener('click', function () {
      const clicked = this.getAttribute('data-for')
      let preSelectedMonth = dropdown.options[dropdown.selectedIndex].value
      dropdown.value = 'all'
      updateDropDown(clicked, preSelectedMonth)
      let sorted = sort(clicked, dropdown.value)
      updateCards(sorted)
      filters.forEach((e) => e.classList.remove('webinars__filter--selected'))
      this.classList.add('webinars__filter--selected')
      this.innerHTML = getTranslation(clicked, this)
      dropdownLabel.innerHTML = getTranslation(clicked, dropdownLabel)
      webinarsNote.innerHTML = getTranslation(clicked, webinarsNote)
    })
  })

  dropdown.addEventListener('change', function () {
    let sorted = sort(currentLang)
    updateCards(sorted)
  })
  loadMonthOptionData()
  loadCardData()
  updateDropDown(currentLang)
  updateCards(sort(currentLang))
})
